var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return __webpack_require__.e("vendors-node_modules_pnpm_es6-promise_4_2_8_node_modules_es6-promise_auto_js-node_modules_pnp-c3fa84").then(next);
};